export const authEndpoints = {
  // Public endpoints
  validateOtp: '/public/v1/auth/validate-otp',
  login: '/public/v1/auth/login',
  registrationStatus: '/public/v1/auth/registration-status',
  forgotPassword: '/public/v1/auth/forgot-password',
  resendRecoveryEmail: '/public/v1/auth/resend-recovery-email',
  verifyRecoveryOtp: '/public/v1/auth/verify-recovery-otp',
  recoverySendTwoFactor: '/public/v1/auth/recovery/2fa/send',
  recoveryVerifyTwoFactor: '/public/v1/auth/recovery/2fa/verify',
  initRegistration: '/public/v1/auth/register/init',
  finalizeRegistration: '/public/v1/auth/register/finalize',
  chooseTwoFactorMethod: '/public/v1/auth/2fa/send',
  verifyTwoFactor: '/public/v1/auth/2fa/verify',
  resendTwoFactor: '/public/v1/auth/2fa/resend',
  refreshToken: '/public/v1/auth/refresh',

  // Private endpoints
  setPassword: '/private/v1/auth/set-password',
  resetPassword: '/private/v1/auth/reset-password',
  sendEmailCode: '/private/v1/auth/send-email-code',
  verifyEmail: '/private/v1/auth/verify-email',
  resendEmailCode: '/private/v1/auth/resend-email-code',
  sendPhoneCode: '/private/v1/auth/send-phone-code',
  verifyPhone: '/private/v1/auth/verify-phone',
  resendPhoneCode: '/private/v1/auth/resend-phone-code',
  registerMlkemKeys: (id:string)=> `/private/v1/auth/registerMlkemKeys/${id}`,
  updateMlkemKeys: (id: string) => `/private/v1/auth/mlkemKeys/${id}`,
  initLogin: '/public/v1/auth/login/init',
  finalizeLogin: '/public/v1/auth/login/finalize',
} as const;

export type AuthEndpointKey = keyof typeof authEndpoints;
